import client from '../httpClient';

const webResUpdateAfterMargedApi = (params) => {
  return client.put('/responses/response-to-customer', JSON.stringify(params), { isShowMessage: true });
};

export default webResUpdateAfterMargedApi;
